webpackJsonp([189066279150898],{

/***/ "./src/data/resume.pdf":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/resume.c015ffef.pdf";

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/ntaylor/Workspace/nate-site/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/ntaylor/Workspace/nate-site/node_modules/babel-plugin-lodash/lib/index.js\",\"/Users/ntaylor/Workspace/nate-site/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/ntaylor/Workspace/nate-site/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[\"/Users/ntaylor/Workspace/nate-site/node_modules/babel-preset-es2015/lib/index.js\",[\"/Users/ntaylor/Workspace/nate-site/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/ntaylor/Workspace/nate-site/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/ntaylor/Workspace/nate-site/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/contact/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Contact;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _me = __webpack_require__("./src/pages/contact/me.jpeg");
	
	var _me2 = _interopRequireDefault(_me);
	
	var _resume = __webpack_require__("./src/data/resume.pdf");
	
	var _resume2 = _interopRequireDefault(_resume);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ContactLink(props) {
	  return _react2.default.createElement(
	    'a',
	    { href: props.url, className: 'fw6 dib pa2 black link hover-blue' },
	    props.type
	  );
	}
	
	function Contact() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'tc' },
	    _react2.default.createElement('img', { src: _me2.default, className: 'br-100 dib', title: 'Photo of Nate Taylor', alt: 'Photo of Nate Taylor' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'dib center' },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Click ',
	        _react2.default.createElement(
	          'a',
	          { href: _resume2.default, className: 'link b black hover-blue' },
	          'here'
	        ),
	        ' to see my resume. '
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'If you\'d like to chat, hit me up at one the following places:'
	      ),
	      _react2.default.createElement(ContactLink, {
	        type: 'Email',
	        url: 'mailto:nathantaylor89@gmail.com',
	        urlText: 'nathantaylor89@gmail.com'
	      }),
	      _react2.default.createElement(ContactLink, {
	        type: 'Github',
	        url: 'https://github.com/ntaylor89/',
	        urlText: 'github.com/ntaylor89'
	      }),
	      _react2.default.createElement(ContactLink, {
	        type: 'LinkedIn',
	        url: 'https://linkedin.com/in/nate-a-taylor/',
	        urlText: 'linkedin.com/in/nateataylor'
	      }),
	      _react2.default.createElement(ContactLink, {
	        type: 'Twitter',
	        url: 'https://twitter.com/Nately89/',
	        urlText: 'twitter.com/Nately89'
	      })
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ "./src/pages/contact/me.jpeg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/me.f03fe641.jpeg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-index-js-5bf7c9f8d3d7ee5c44fb.js